
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[areaId]/events/[eventId]/number",
      function () {
        return require("private-next-pages/[areaId]/events/[eventId]/number.tsx");
      }
    ]);
  